import { ApiError } from '../errors/api-error.js';

export class TenantOnboardingService {
    constructor(api) { this.api = api; }

    async onboard(config) {
        try { const r = await this.api.onboard(config); return { success: true, data: r.data, message: r.message }; }
        catch (e) {
            if (e instanceof ApiError) throw e;
            if (e.statusCode || e.status) throw ApiError.fromResponse(e);
            throw new ApiError(e.message || 'Onboarding failed', 500, 'UNKNOWN_ERROR', e);
        }
    }
}
